var _circle, _path, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 250,
    viewBox: "0 0 252 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 127,
    cy: 125,
    r: 125,
    fill: "url(#paint0_radial_829_209)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.45 225.896C163.461 225.896 199.95 189.407 199.95 144.396C199.95 99.3843 163.461 62.8955 118.45 62.8955C73.439 62.8955 36.9502 99.3843 36.9502 144.396C36.9502 189.407 73.439 225.896 118.45 225.896Z",
    fill: "url(#paint1_linear_829_209)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 124,
    r: 54,
    fill: "url(#paint2_radial_829_209)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_829_209",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.6923 72.1154) rotate(38.8534) scale(222.249)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566108
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661829,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#1B1B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#2B2C2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_829_209",
    x1: 118.45,
    y1: 21.6668,
    x2: 118.45,
    y2: 275.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2484,
    stopColor: "#0E0A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3927,
    stopColor: "#100B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5104,
    stopColor: "#130D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    stopColor: "#17105D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7067,
    stopColor: "#1C1476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7387,
    stopColor: "#1E1581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E15C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_829_209",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9231 101.154) rotate(38.8534) scale(96.0114)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566108,
    stopColor: "#3B3FB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661829,
    stopColor: "#2D32B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#2C30B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#373EFE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIc);
export default __webpack_public_path__ + "static/media/header_ic.c623e1df3b357b2178fe36fe530312ef.svg";
export { ForwardRef as ReactComponent };